// (B) 플레인 Card — antd Card 대체(순수 시각). antd DOM 미러링:
// .om-card(+.om-card-bordered) > .om-card-head > .om-card-head-wrapper > .om-card-head-title / .om-card-body.
// 소비처 SCSS(officemail/settings)가 시각을 정의(.om-card*) → 여기선 구조+antd base(styles/omCard.css)만.
import type { OmwCardProps } from '../api/OmwCard'
import { cx } from './cx'
import '../styles/omwCard.css'

export function PlainCard({ title, className, style, children }: OmwCardProps) {
  return (
    <div className={cx('om-card', 'om-card-bordered', className)} style={style}>
      {title != null && (
        <div className="om-card-head">
          <div className="om-card-head-wrapper">
            <div className="om-card-head-title">{title}</div>
          </div>
        </div>
      )}
      <div className="om-card-body">{children}</div>
    </div>
  )
}
